// AUTO-GENERATED by scripts/generate-book-covers.js. Do not edit by hand.
// Drop a cover in src/assets/covers/ named after the book's slug.


export const bookCovers = {

};
